import { ExperimentGetter } from 'frontend/types';

export function isInMathSubpackExperiment(experimentGetter: ExperimentGetter): boolean {
  return experimentGetter('math_subpack_01_2023', 'experiment');
}
